import React, { useMemo, useState } from 'react';
import Button from '../../../component/ui/Button';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
	batch_create_bulk,
	Group_bulk_import,
	product_create_bulk,
} from '../../../store/action/product';
import { exportProducts } from '../../../services/products';
import { Link } from 'react-router-dom';

const BulkImport = ({ onClose, reloadTable, type, productID }) => {
	const [selectedFile, setSelectedFile] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [loader, setLoader] = useState(false);
	const dispatch = useDispatch();

	const handleDownload = async (type, is_sample = false) => {
		try {
			const params = {
				type,
				mime_type: 'excel',
				is_sample,
			};
			const data = await exportProducts(params);
			toast.success('Download Successfully.');
			if (data?.signed_url) {
				window.open(data.signed_url);
			}
		} catch (err) {
			toast.error('Something went wrong!');
		}
	};

	const handleFileChange = (event) => {
		const file = event?.target?.files[0];
		const fileExtension = file.name.split('.').pop().toLowerCase();
		const allowedExtensions = ['xlsx', 'xls', 'csv'];
		if (allowedExtensions.includes(fileExtension)) {
			setSelectedFile(file);
			setErrorMessage('');
		} else {
			setSelectedFile(null);
			setErrorMessage('Please upload a valid Excel or CSV file.');
		}
	};

	const handleSave = () => {
		setLoader(true);
		if (selectedFile) {
			let formData = new FormData();
			formData.append('file', selectedFile);
			if (type === 'product') {
				dispatch(product_create_bulk(formData)).then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						setLoader(false);
					} else {
						toast.error(res.response?.data?.message.map((err) => err.message).join('\n'));
						setLoader(false);
					}
					reloadTable();
					onClose();
				});
				setLoader(false);
			}
			if (type === 'batch') {
				dispatch(batch_create_bulk(productID, formData)).then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						setLoader(false);
					} else {
						toast.error(res.response?.data?.message.map((err) => err.message).join('\n'));
						setLoader(false);
					}
					reloadTable();
					onClose();
				});
				setLoader(false);
			}
			if (type === 'group') {
				dispatch(Group_bulk_import(productID, formData)).then((res) => {
					if (res?.success) {
						toast.success(res?.message);
						reloadTable();
						setLoader(false);
					} else {
						toast.error(res.response?.data?.message.map((err) => err.message).join('\n'));
						setLoader(false);
					}
					reloadTable();
					onClose();
				});
				setLoader(false);
			}
		} else {
			toast.error('No file selected or invalid file type');
			setLoader(false);
		}
	};

	const getType = useMemo(() => {
		const typeMap = {
			product: 'Products',
			group: 'Product Groups',
		};
		return typeMap[type];
	}, [type]);

	return (
		<div className="">
			{type === 'product' && (
				<div className="">
					<div
						className="text-decoration-underline text-primary cursor-pointer text-end"
						onClick={() => handleDownload(type, true)}
					>{`Download Sample ${getType} File For Bulk Import`}</div>
					<div
						className="text-decoration-underline text-primary cursor-pointer text-end"
						onClick={() => handleDownload('group', true)}
					>
						Download Product Group Excel File
					</div>
					<div
						className="text-decoration-underline text-primary cursor-pointer text-end"
						onClick={() => handleDownload('category', true)}
					>
						Download Product Category Excel File
					</div>
				</div>
			)}
			{type === 'group' && (
				<div className="text-end">
					<Link to="https://pharmnex.s3.ap-south-1.amazonaws.com/public/sample/inventory/sample_product_group.xlsx">{`Download Sample Product Group File For Bulk Import`}</Link>
				</div>
			)}
			{type === 'batch' && (
				<div className="text-end">
					<Link to="https://pharmnex.s3.ap-south-1.amazonaws.com/public/sample/inventory/sample_create_product_batch.xlsx">{`Download Sample Product Batch File For Bulk Import`}</Link>
				</div>
			)}
			<div>
				<div className="add-productgroup-form">
					<label
						className="form-label"
						htmlFor={`file`}
					>
						{'Upload a file'}
						{<span style={{ color: 'red' }}>*</span>}
					</label>
					<input
						className={`form-control mb-lg-4 mb-md-3 mb-sm-3 mb-3 inpuBG `}
						type="file"
						label="Upload a file"
						placeholder="Select Group"
						onChange={handleFileChange}
						name="file"
					/>
					{errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
				</div>
				<div className="add-productgroup-footer d-flex justify-content-between">
					<Button
						type="button"
						button="Save"
						className="btn-primary add-pgroup"
						onClick={handleSave}
						disabled={!selectedFile}
						loader={loader}
					/>
					<Button
						type="button"
						button="Cancel"
						className="btn-dark add-pgroup"
						onClick={onClose}
					/>
				</div>
			</div>
		</div>
	);
};

export default BulkImport;
